import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import ShareButtons from "../components/Share";
import { useT } from "../lib/site";
import "@/Landing.css";

const date = (d) => new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });

export default function NewsDetailPage() {
  const { slug } = useParams();
  const t = useT();
  const [item, setItem] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    setItem(null); setMissing(false);
    api.get(`/news/slug/${encodeURIComponent(slug)}`).then((r) => { setItem(r.data); document.title = `${r.data.title} — Kholid Archery Academy`; }).catch(() => setMissing(true));
    window.scrollTo(0, 0);
  }, [slug]);
  const url = typeof window !== "undefined" ? `${window.location.origin}/berita/${slug}` : "";
  return <div className="landing news-page" data-testid="news-detail-page">
    <header className="news-page-top"><Link to="/" className="lp-brand"><img src="/kha-emblem.png" alt="KHA" /><span>KHOLID <b>ARCHERY</b> ACADEMY</span></Link><a href="/#berita" className="outline-btn compact" data-testid="news-back"><ArrowLeft size={14} /> {t("news.back")}</a></header>
    {missing ? <section className="lp-section"><h2>Berita tidak ditemukan</h2><p className="muted">Mungkin berita ini sudah tidak ditayangkan.</p><Link to="/" className="primary-btn">Kembali ke beranda</Link></section>
      : !item ? <section className="lp-section"><p className="muted">Memuat berita...</p></section>
      : <article className="lp-reader news-article" data-testid="news-article">
        {item.image_url && <img src={item.image_url} alt={item.title} />}
        <div className="lp-reader-body"><p className="eyebrow">{item.category} · {date(item.date)}</p><h1 data-testid="news-title">{item.title}</h1>
          <ShareButtons url={url} title={item.title} text={item.excerpt} label={t("news.share")} />
          {item.content.split(/\n\s*\n/).map((para, i) => <p key={i}>{para}</p>)}
          <ShareButtons url={url} title={item.title} text={item.excerpt} label={t("news.share")} />
          <a href="/#daftar" className="primary-btn" data-testid="news-reader-cta">{t("news.cta")} <ArrowRight size={15} /></a>
        </div>
      </article>}
  </div>;
}
